import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
//scrollBehavior(to, from, savePosition){
//	if(savePosition){
//			return savePosition;
//	}else{
//		return {x:0, y:0};
//	}
//},
  routes: [
    {
    	path: '/login',
      name: 'login',
      component: resolve => require(['@/components/login/login'],resolve)
    },
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/components/index'],resolve)
    },
    {
      path: '/ddLogin',
      name: 'ddLogin',
      component:resolve=>require(['@/components/login/ddLogin'],resolve)
    },

     {
      path: '/Header',
      name: 'header',
      component:resolve=>require(['@/components/demo/header'],resolve)
    },

    //demo
    //流程管理
    {
      path: '/workdemo',
      name: 'workdemo',
      component:resolve=>require(['@/components/demo/worker'],resolve)
    },{
      path: '/Prolistdemo',
      name: 'Prolistdemo',
      component:resolve=>require(['@/components/demo/bpm/list'],resolve)
    },{
      path: '/Detailsdemo',
      name: 'Detailsdemo',
      component: resolve=>require(['@/components/demo/bpm/details'],resolve)
    },   {
      path: '/projectFile/Details',
      name: 'projectFileDetails',
			component: resolve=>require(['@/components/bpm/projectFile/details'],resolve)
    },{
      path: '/Deliver',
      name: 'Deliver',
      component: resolve=>require(['@/components/demo/bpm/sp-deliver'],resolve)
    },{
      path: '/Reject',
      name: 'Reject',
      component: resolve=>require(['@/components/demo/bpm/sp-reject'],resolve)
    },{
      path: '/Submit',
      name: 'Submit',
      component: resolve=>require(['@/components/demo/bpm/sp-submit'],resolve)
    },{
      path: '/Selectuser',
      name: 'Selectuser',
      component: resolve=>require(['@/components/demo/module/selectuser'],resolve)
    },{
      path: '/lcQuerydemo',
      name: 'lcQuerydemo',
      component: resolve=>require(['@/components/demo/bpm/advanced-query'],resolve)
    },{
      path: '/Sortdemo',
      name: 'Sortdemo',
      component: resolve=>require(['@/components/demo/bpm/sort'],resolve)
    }, {
      path: '/costdemo',
      name: 'Costdemo',
      component: resolve=>require(['@/components/demo/cost/list'],resolve)
    },
     {
      path: '/costdetails',
      name: 'Costdetails',
      component: resolve=>require(['@/components/demo/cost/details'],resolve)
    },
    //任务管理
    {
      path: '/taskListdemo',
      name: 'taskListdemo',
      component: resolve=>require(['@/components/demo/task/list'],resolve),
      meta: {keepAlive: true}
    },{
      path: '/taskDetailsdome',
      name: 'taskDetailsdome',
      component: resolve=>require(['@/components/demo/task/details'],resolve)
    }, {
      path: '/taskQuerydemo',
      name: 'taskQuerydemo',
      component: resolve=>require(['@/components/demo/task/task-query'],resolve)
    }, {
      path: '/priceAdd',
      name: 'priceAdd',
      component: resolve=>require(['@/components/demo/priceAdd'],resolve)
    },
    //demo结束


    //合同管理
    {
      path: '/contractList',
      name: 'contractList',
      component: resolve=>require(['@/components/contract/contractListTabbor'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/contractList2',
      name: 'contractList2',
      component: resolve=>require(['@/components/contract/contractList'],resolve)
    },
    {
      path: '/contractDetails/:id',
      name: 'contractDetails',
      component: resolve=>require(['@/components/contract/Details'],resolve)
    },
    {
      path: '/contractAdd',
      name: 'contractAdd',
      component: resolve=>require(['@/components/contract/contractAdd'],resolve)
    },
    {
      path: '/contractAddCopy',
      name: 'contractAddCopy',
      component: resolve=>require(['@/components/contract/contractAddCopy'],resolve)
    },
		//报价审批列表
    {
      path: '/priceApprovalList',
      name: 'priceApprovalList',
      component: resolve=>require(['@/components/priceApproval/list'],resolve),
      meta: {keepAlive: true}
    },
    //带我评价项目
    {
      path: '/toDoEvaluationProjectList',
      name: 'toDoEvaluationProjectList',
      component: resolve=>require(['@/components/toEvaluated/toDoProjectList'],resolve),
      meta: {keepAlive: true}
    },
    //评价
    {
      path: '/project/evaluationScore',
      name: 'projectEvaluationScore',
      component: resolve=>require(['@/components/project/evaluationScore/score'],resolve)
    },

    //发票管理
     {
      path: '/invoiceList',
      name: 'invoiceList',
      component: resolve=>require(['@/components/demo/invoice/list'],resolve)
    },{
      path: '/invoiceDetails',
      name: 'invoiceDetails',
      component: resolve=>require(['@/components/demo/invoice/invoiceDetails'],resolve)
    },
    //日志管理
    {
      path: '/dailyadd',
      name: '日志添加页面',
      component: resolve=>require(['@/components/demo/daily/dailyAdd'],resolve)
    }, {
      path: '/dailylist',
      name: '日志列表',
      component: resolve=>require(['@/components/demo/daily/dailylist'],resolve)
    },{
      path: '/dailyDetails',
      name: '日志详情',
      component: resolve=>require(['@/components/demo/daily/dailyDetails'],resolve)
    },
    //页面元素样式
    {
      path: '/format',
      name: 'format',
      component: resolve=>require(['@/components/demo/mint/format'],resolve)
    },
     {
      path: '/talk',
      name: 'talk',
      component: resolve=>require(['@/components/demo/bpm/talk'],resolve)
    },{
      path: '/format',
      name: 'demo',
      component: resolve=>require(['@/components/demo/mint/format'],resolve)
    },
     {
      path: '/validate',
      name: 'validate',
      component: resolve=>require(['@/components/demo/validate/Validate2'],resolve)
    },
     {
      path: '/validate1',
      name: 'validate1',
      component: resolve=>require(['@/components/demo/validate/Validate1'],resolve)
    },
     {
      path: '/evaluationScore',
      name: '项目评价',
      component: resolve=>require(['@/components/demo/evaluationScore/score'],resolve)
    },
//  {
//	   path: '/ddCheck',
//	   name: 'ddCheck',
//	   component: resolve=>require(['@/components/demo/ddTest/ddCheckDemo'],resolve)
//  },

    //demo结束




    //流程管理
    {
      path: '/Prolist',
      name: 'Prolist',
      component:resolve=>require(['@/components/bpm/list'],resolve)
    },

    //项目附件审批列表
    {
      path: '/toDoProjectFile',
      name: 'toDoProjectFile',
      component:resolve=>require(['@/components/bpm/projectFile/toDoList'],resolve),
      meta: {keepAlive: true}
    },{
      path: '/myRequestProjectFile',
      name: 'myRequestProjectFile',
      component:resolve=>require(['@/components/bpm/projectFile/myRequestList'],resolve),
      meta: {keepAlive: true}
    },{
      path: '/copyProjectFile',
      name: 'copyProjectFile',
      component:resolve=>require(['@/components/bpm/projectFile/copyList'],resolve),
      meta: {keepAlive: true}
    },

    //合同审批列表
    {
      path: '/toDoContractApproval',
      name: 'toDoContractApproval',
      component:resolve=>require(['@/components/bpm/contractApproval/toDoList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/myRequestContractApproval',
      name: 'myRequestContractApproval',
      component:resolve=>require(['@/components/bpm/contractApproval/myRequestList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/copyContractApproval',
      name: 'copyContractApproval',
      component:resolve=>require(['@/components/bpm/contractApproval/copyList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/contractApproval/Details',
      name: 'contractApprovalDetails',
      component:resolve=>require(['@/components/bpm/contractApproval/details'],resolve)
    },

    //交接单审批列表
    {
      path: '/toDoContractPerform',
      name: 'toDoContractPerform',
      component:resolve=>require(['@/components/bpm/perform/toDoList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/myRequestContractPerform',
      name: 'myRequestContractPerform',
      component:resolve=>require(['@/components/bpm/perform/myRequestList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/copyContractPerform',
      name: 'copyContractPerform',
      component:resolve=>require(['@/components/bpm/perform/copyList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/contractPerform/Details',
      name: 'contractPerformDetails',
      component:resolve=>require(['@/components/bpm/perform/details'],resolve)
    },
    {
      path: '/contractPerform/add',
      name: 'contractPerformAdd',
      component:resolve=>require(['@/components/bpm/perform/performAdd'],resolve)
    },
    //报价审批
     {
      path: '/toDoPrice',
      name: 'toDoPrice',
      component:resolve=>require(['@/components/bpm/price/toDoList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/myRequestContractPrice',
      name: 'myRequestContractPrice',
      component:resolve=>require(['@/components/bpm/price/myRequestList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/copyContractPrice',
      name: 'copyContractPrice',
      component:resolve=>require(['@/components/bpm/price/copyList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/contractPrice/Details',
      name: 'contractPriceDetails',
      component:resolve=>require(['@/components/bpm/price/details'],resolve)
    },
    //报价变更审批
    {
      path: '/toDoChangePrice',
      name: 'toDoChangePrice',
      component:resolve=>require(['@/components/bpm/priceChange/toDoList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/myRequestChangeContractPrice',
      name: 'myRequestChangeContractPrice',
      component:resolve=>require(['@/components/bpm/priceChange/myRequestList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/copyChangeContractPrice',
      name: 'copyChangeContractPrice',
      component:resolve=>require(['@/components/bpm/priceChange/copyList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/priceChange/Details',
      name: 'priceChangeDetails',
      component:resolve=>require(['@/components/bpm/priceChange/details'],resolve)
    },
    //项目审批列表
    {
      path: '/toDoProjectApproval',
      name: 'toDoProjectApproval',
      component:resolve=>require(['@/components/bpm/project/toDoList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/myRequestProjectApproval',
      name: 'myRequestProjectApproval',
      component:resolve=>require(['@/components/bpm/project/myRequestList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/copyProjectApproval',
      name: 'copyProjectApproval',
      component:resolve=>require(['@/components/bpm/project/copyList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/projectApproval/Details',
      name: 'projectApprovalDetails',
      component:resolve=>require(['@/components/bpm/project/details'],resolve)
    },

    //废弃审批列表
    {
      path: '/toDoContractAband',
      name: 'toDoContractAband',
      component:resolve=>require(['@/components/bpm/abandon/toDoList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/myRequestContractAband',
      name: 'myRequestContractAband',
      component:resolve=>require(['@/components/bpm/abandon/myRequestList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/copyContractAband',
      name: 'copyContractAband',
      component:resolve=>require(['@/components/bpm/abandon/copyList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/contractAbandon/Details',
      name: 'contractAbandonDetails',
      component:resolve=>require(['@/components/bpm/abandon/details'],resolve)
    },

    //变更审批列表
    {
      path: '/toDoContractAlteration',
      name: 'toDoContractAlteration',
      component:resolve=>require(['@/components/bpm/alteration/toDoList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/myRequestContractAlteration',
      name: 'myRequestContractAlteration',
      component:resolve=>require(['@/components/bpm/alteration/myRequestList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/copyContractAlteration',
      name: 'copyContractAlteration',
      component:resolve=>require(['@/components/bpm/alteration/copyList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/contractAlteration/Details',
      name: 'contractAlterationDetails',
      component:resolve=>require(['@/components/bpm/alteration/details'],resolve)
    },

    //终止审批列表
    {
      path: '/toDoContractTermination',
      name: 'toDoContractTermination',
      component:resolve=>require(['@/components/bpm/termination/toDoList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/myRequestContractTermination',
      name: 'myRequestContractTermination',
      component:resolve=>require(['@/components/bpm/termination/myRequestList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/copyContractTermination',
      name: 'copyContractTermination',
      component:resolve=>require(['@/components/bpm/termination/copyList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/contractTermination/Details',
      name: 'contractTerminationDetails',
      component:resolve=>require(['@/components/bpm/termination/details'],resolve)
    },

    //项目变更审批列表
    {
      path: '/toDoProjectChange',
      name: 'toDoProjectChange',
      component:resolve=>require(['@/components/bpm/projectChange/toDoList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/myRequestProjectChange',
      name: 'myRequestProjectChange',
      component:resolve=>require(['@/components/bpm/projectChange/myRequestList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/copyProjectChange',
      name: 'copyProjectChange',
      component:resolve=>require(['@/components/bpm/projectChange/copyList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/projectChange/Details',
      name: 'projectChangeDetails',
      component:resolve=>require(['@/components/bpm/projectChange/details'],resolve)
    },

    //差旅报销审批列表
    {
      path: '/toDoFinanceTravel',
      name: 'toDoFinanceTravel',
      component:resolve=>require(['@/components/bpm/travel/toDoList'],resolve),
      meta: {keepAlive: true}
    },{
      path: '/myRequestFinanceTravel',
      name: 'myRequestFinanceTravel',
      component:resolve=>require(['@/components/bpm/travel/myRequestList'],resolve),
      meta: {keepAlive: true}
    },{
      path: '/copyFinanceTravel',
      name: 'copyFinanceTravel',
      component:resolve=>require(['@/components/bpm/travel/copyList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/financeTravel/Details',
      name: 'financeTravelDetails',
      component:resolve=>require(['@/components/bpm/travel/details'],resolve)
    },
    //费用报销审批列表
    {
      path: '/toDoFinanceCost',
      name: 'toDoFinanceCost',
      component:resolve=>require(['@/components/bpm/cost/toDoList'],resolve),
      meta: {keepAlive: true}
    },{
      path: '/myRequestFinanceCost',
      name: 'myRequestFinanceCost',
      component:resolve=>require(['@/components/bpm/cost/myRequestList'],resolve),
      meta: {keepAlive: true}
    },{
      path: '/copyFinanceCost',
      name: 'copyFinanceCost',
      component:resolve=>require(['@/components/bpm/cost/copyList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/financeCost/Details',
      name: 'financeCostDetails',
      component:resolve=>require(['@/components/bpm/cost/details'],resolve)
    },
    //借款申请审批列表
    {
      path: '/toDoFinanceBorrowing',
      name: 'toDoFinanceBorrowing',
      component:resolve=>require(['@/components/bpm/borrowing/toDoList'],resolve),
      meta: {keepAlive: true}
    },{
      path: '/myRequestFinanceBorrowing',
      name: 'myRequestFinanceBorrowing',
      component:resolve=>require(['@/components/bpm/borrowing/myRequestList'],resolve),
      meta: {keepAlive: true}
    },{
      path: '/copyFinanceBorrowing',
      name: 'copyFinanceBorrowing',
      component:resolve=>require(['@/components/bpm/borrowing/copyList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/financeBorrowting/Details',
      name: 'financeBorrowtingDetails',
      component:resolve=>require(['@/components/bpm/borrowing/details'],resolve)
    },

    //发票审批列表
    {
      path: '/toDoInvoice',
      name: 'toDoInvoice',
      component:resolve=>require(['@/components/bpm/invoice/toDoList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/myRequestInvoice',
      name: 'myRequestInvoice',
      component:resolve=>require(['@/components/bpm/invoice/myRequestList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/copyInvoice',
      name: 'copyInvoice',
      component:resolve=>require(['@/components/bpm/invoice/copyList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/invoice/Details',
      name: 'invoiceDetails',
      component:resolve=>require(['@/components/bpm/invoice/details'],resolve)
    },


    //高级查询
    {
      path: '/Sort',
      name: 'Sort',
			component: resolve=>require(['@/components/bpm/tabbar'],resolve)
    },{
      path: '/myRequestSort',
      name: 'myRequestSort',
			component: resolve=>require(['@/components/bpm/myRequestSort'],resolve)
    },{
      path: '/copySort',
      name: 'copySort',
			component: resolve=>require(['@/components/bpm/copySort'],resolve)
    },

    //审批转交
    {
      path: '/bpmDeliver',
      name: 'bpmDeliver',
      component:resolve=>require(['@/components/bpm/bottm/sp-deliver'],resolve)
    },
    //审批驳回
    {
      path: '/bpmReject',
      name: 'bpmReject',
      component:resolve=>require(['@/components/bpm/bottm/sp-reject'],resolve)
    },
    //审批提交
    {
      path: '/bpmSubmit',
      name: 'bpmSubmit',
      component:resolve=>require(['@/components/bpm/flowStartInfo'],resolve)
    },

    //任务管理
    {
      path: '/taskList',
      name: 'taskList',
      component: resolve=>require(['@/components/task/taskList'],resolve),
      meta: {keepAlive: true}
    },{
      path: '/taskDetails',
      name: 'taskDetails',
      component: resolve=>require(['@/components/task/taskDetail'],resolve)
    },{
      path: '/addTaskLog',
      name: 'addTaskLog',
      component: resolve=>require(['@/components/task/addTaskLog'],resolve)
    },{
      path: '/editTaskLog',
      name: 'editTaskLog',
      component: resolve=>require(['@/components/task/editTaskLog'],resolve)
    },{
      path: '/taskQuery',
      name: 'taskQuery',
      component: resolve=>require(['@/components/demo/task/task-query'],resolve)
    },

    //发票管理
    {
      path: '/myRequestListInvoice',
      name: 'myRequestListInvoice',
      component: resolve=>require(['@/components/invoice/myRequestList'],resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/invoiceDetails/Details',
      name: 'invoiceDetails',
      component: resolve=>require(['@/components/invoice/invoiceDetails'],resolve)
    },
    {
      path: '/myRequestListInvoice/Details',
      name: 'myRequestListInvoiceDetails',
      component: resolve=>require(['@/components/invoice/invoiceDetails'],resolve)
    },
    {
      path: '/myRequestListInvoice/edit',
      name: 'myRequestListInvoiceEdit',
      component: resolve=>require(['@/components/invoice/invoiceEdit'],resolve)
    },

    /*日志管理*/
    {
      path: '/summaryList',
      name: 'summaryList',
      component: resolve=>require(['@/components/summary/summaryList'],resolve)
    },{
      path: '/summaryList2',
      name: 'summaryList2',
      component: resolve=>require(['@/components/summary/summaryList2'],resolve),
      meta: {keepAlive: true}
    },{
      path: '/summaryAdd',
      name: 'summaryAdd',
      component: resolve=>require(['@/components/summary/summaryAdd'],resolve)
    },
    {
      path: '/summaryDetail',
      name: 'summaryDetail',
      component: resolve=>require(['@/components/summary/summaryDetail'],resolve)
    },
    {
      path: '/swiperList',
      name: 'swiperList',
      component: resolve=>require(['@/components/summary/swiperList'],resolve)
    },

    /*钉钉端消息链接（钉钉端没有实体信息的链接）*/
    {
      path: '/sysComment',
      name: 'sysComment',
      component: resolve=>require(['@/components/lib/noEntityInformationDDUrl'],resolve)
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js